import { PolicyType, PolicyTypes } from './PasswordPoliciesDtoModel';

export const ByValueRules = {
  MinimumLength: 'minimumLength',
  MaximumLength: 'maximumLength',
} as const;

export interface BasePasswordPolicy {
  readonly name: string;
  readonly type: PolicyType;
}

export interface ByPatternPolicy extends BasePasswordPolicy {
  readonly type: typeof PolicyTypes.ByPattern;
  readonly pattern: RegExp;
}

export interface ByValuePolicy extends BasePasswordPolicy {
  readonly type: typeof PolicyTypes.ByValue;
  readonly value: number;
}

export type PasswordPolicy = ByPatternPolicy | ByValuePolicy;

export interface PasswordPolicies {
  passwordPolicies: PasswordPolicy[];
}
